import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Container from 'ls-common-client/dist/components/Container';
import Text from 'ls-common-client/dist/components/Text';
import LayoutContainer from '../../../components/LayoutContainer';
import LazyLoad from '../../../components/LazyLoad';
import { GalleryPlaceholder } from '../../../assets/profile';
import slugify from '../../../utils/slugify';
import getCategoryArticleFeatureImage from '../../../utils/getCategoryArticleFeatureImage';

const StyledCategoryListRoot = styled(Container)`
  background-color: #f8f8f8;
  padding: 50px 0 100px;
  background-size: cover;
  background-position: center;
  background-repeat: repeat-x;

  @media (max-width: 1024px) and (orientation: portrait), (max-width: 767px) {
    padding-bottom: 30px;
    padding-top: 10px;
  }

  @media (max-width: 767px) {
    padding-top: 0px;
  }
`;

const StyledHeading = styled.h2`
  font-size: 26px;
  margin-bottom: 10px;
  font-weight: bold;
  @media (max-width: 767px) {
    line-height: 1.2em;
  }
`;

const StyledSubHeading = styled.h3`
  color: #757575;
  font-size: 20px;
  margin-top: 0;
  font-weight: 500;
  @media (max-width: 767px) {
    font-size: 18px;
  }
`;

const StyledCategoryList = styled(Container)`
  max-width: 1150px;
  margin: 0 auto;
  margin-top: 50px;

  ul {
    list-style: none;
    padding: 0;
    display: flex;
    flex-wrap: wrap;
    flex: 0 0 167px;
    margin: 0 -20px;
  }

  a {
    display: flex;
    width: 167px;
    height: 167px;
    align-items: flex-end;
    color: #ffffff;
    font-size: 16px;
    font-weight: 600;
    border-radius: 10px;
    position: relative;
    padding: 14px 10px;
    overflow: hidden;
    margin: 0 14px 40px 14px;
    transition: all 0.3s ease;
  }

  a img {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    object-fit: cover;
    width: 100%;
    height: 100%;
  }

  a:after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background-image: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0),
      rgba(0, 0, 0, 0.67) 105%
    );
  }

  a:hover {
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.45);
  }

  a span {
    position: relative;
    z-index: 1;
    line-height: 1.3em;
  }

  @media (max-width: 1024px) and (orientation: portrait), (max-width: 767px) {
    max-width: 720px;

    ul {
      margin: 0;
    }
    li {
      margin-right: 15px;
    }
    a {
      margin: 0 1px 20px;
      width: 160px;
      height: 160px;
    }
  }

  @media (max-width: 767px) {
    max-width: 345px;

    ul {
      margin: 0;
      justify-content: space-between;
    }
    li {
      margin: 0;
    }
  }
`;

const CategoryList = ({ categories }) => {
  return (
    <StyledCategoryListRoot className="Guides__CategoryList__Root">
      <LayoutContainer>
        <Container>
          <StyledHeading className="Guides__CategoryList__Heading">
            Localsearch Guides & Cost Resources
          </StyledHeading>
          <StyledSubHeading className="Guides__CategoryList__SubHeading">
            Search locally for a quick, easy and cost-effective solution to all
            of life&apos;s unwanted hassles, such as finding a removalist,
            installing a towbar and even renovating a kitchen. Our how-to
            walkthroughs, cost guides and in-depth features arm you with
            independent, expert advice to take the mystery and misery out of any
            project or problem.
          </StyledSubHeading>
          <StyledCategoryList className="Guides__CategoryList__Categories">
            <ul>
              {categories.map(({ name, featureImage }) => (
                <li key={name}>
                  <Link to={`/guides/${slugify(name)}`}>
                    <LazyLoad>
                      <img
                        src={getCategoryArticleFeatureImage(name, featureImage)}
                        alt={name}
                        onError={e => {
                          e.target.onerror = null;
                          e.target.src = GalleryPlaceholder;
                        }}
                        loading="lazy"
                      />
                    </LazyLoad>
                    <Text>{name}</Text>
                  </Link>
                </li>
              ))}
            </ul>
          </StyledCategoryList>
        </Container>
      </LayoutContainer>
    </StyledCategoryListRoot>
  );
};

export default CategoryList;
